import React, {Component} from 'react';
import printYear from '../core/CollectionHelper'
import './Collections.css'
import {withTranslation} from "react-i18next";

class Page extends Component {

    render() {
        const {t} = this.props;
        const {album} = this.props;
        return (
            <div>
                <a href={`/collections/${album.name}`}>
                    <div className='collection-main-photo'
                         style={{backgroundImage: `url(/img/collections/${album.dirName}/${album.mainPhoto})`}}>
                    </div>
                </a>
                <div className='collection-description text-center text-uppercase'>
                    <h4>
                        <span className='underlined'>
                            <a href={`/collections/${album.name}`}>
                            {album.name}
                            </a>
                        </span>
                    </h4>
                    <div>
                        <div className='collection-note'>
                            {printYear(album.year, album.season)}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
const CollectionView = withTranslation()(Page);
export default CollectionView;


// WEBPACK FOOTER //
// ./src/components/CollectionView.jsx